import { useSnackbar } from 'notistack';
import { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import MobileApplicationThemeForm from './MobileApplicationThemeForm';
import publisherService from '../../services/publisherService';
import mobileApplicationThemeService from '../../services/mobileApplicationThemeService';
import { brandConfig } from '../../branding/brandConfig';

const MobileApplicationThemeCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const [errors, setErrors] = useState<string[]>([]);

  const { checkPermission } = useCheckPermission();
  const [publishers, setPublishers] = useState<any[]>([]);
  const [existingThemes, setExistingThemes] = useState<any[]>([]);

  // Stable identity — inline object + Formik enableReinitialize wiped logoId after upload.
  const entity = useMemo(
    () => ({
      id: 0,
      logoId: 0,
      backgroundImageId: 0,
      primaryColor: brandConfig.colors.primary,
      secondaryColor: brandConfig.colors.secondary,
      iconPrimaryColor: brandConfig.colors.primary,
      iconSecondaryColor: brandConfig.colors.iconSecondary,
      illustrationPrimaryColor: brandConfig.colors.primary,
      startDate: null,
      endDate: null,
    }),
    []
  );

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    publisherService
      .list()
      .then((response: any) => {
        if (!response.hasError) {
          setPublishers(response.records);
        } else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    mobileApplicationThemeService
      .create(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          if (onSave) onSave(response.result);
          if (navigateBack) navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    mobileApplicationThemeService
      .list()
      .then((response) => {
        if (!response.hasError) {
          setExistingThemes(response.records);
        } else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  return (
    <MobileApplicationThemeForm
      entity={entity}
      readonly={!checkPermission(['CreateMobileApplicationTheme'])}
      onSubmit={onSubmit}
      errors={errors}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate(-1)
      }
      publishers={publishers}
      existingThemes={existingThemes}
    />
  );
};

export default MobileApplicationThemeCreate;
